import React, { FC, MouseEvent } from 'react';
import PermitType from '../../../../types/permit.type';
import RadioBtnsContainer from '../../../../components/form/radios/RadioBtnsContainer';
import RadioOutlineBtn from '../../../../components/form/radios/RadioOutlineBtn';
import { usePermitRequestContext } from '../../../../contexts/PermitRequestContext';
import { useProjectConfigContext } from '../../../../contexts/ProjectConfigContext';

type Props = {
  handleClick: (e: MouseEvent<HTMLInputElement>) => void
}

const DisabilityCardPermit: FC<Props> = ({ handleClick }) => {

  const { projectConfigState } = useProjectConfigContext();
  const { Formik } = usePermitRequestContext();
  const { values } = Formik;
  const permitType = values.permitType;

  const label = `בעל תו נכה?`;
  const yesLabel = 'כן';
  const noLabel = 'לא';

  const permitTypes = projectConfigState.addRequestPageConfig.permitTypes;
  const handicapped = permitTypes.handicapped;

  if (!handicapped) {
      return null;
  }

  return (
    <div className='row'>
      <div className='col-12'>
        <RadioBtnsContainer label={label}>
          <RadioOutlineBtn
            isChecked={permitType !== PermitType.HANDICAPPED}
            label={yesLabel}
            value={PermitType.REGULAR}
            onClick={handleClick}
            id="disabilityCardYes"
            name='disabilityCard'
          />
          <RadioOutlineBtn
            isChecked={permitType === PermitType.HANDICAPPED}
            label={noLabel}
            value={PermitType.HANDICAPPED}
            onClick={handleClick}
            id="disabilityCardNo"
            name='disabilityCard'
          />
        </RadioBtnsContainer>
      </div>
    </div>
  );
}

export default DisabilityCardPermit;